const home = {
  nav_home: 'Accueil',
  nav_guides: 'Guides',
  nav_reviews: 'Avis',
  nav_shipping: 'Livraison',
  nav_qc: 'QC',
  nav_safety: 'Sécurité',
  nav_faq: 'FAQ',
  nav_about: 'À Propos',
  nav_contact: 'Contact',
  nav_article: 'Article',
  lang_english: 'English',
  lang_french: 'Français',
  lang_danish: 'Dansk',
  lang_german: 'Deutsch',
  hero_title: 'AllChinaBuy Spreadsheet : Votre Ressource Complète d\'Achat et de Livraison',
  hero_subtitle: 'Trouvez, comparez et comprenez les produits AllChinaBuy avec une ressource pratique.',
  hero_desc: 'Le AllChinaBuy Spreadsheet rassemble les ressources de recherche de produits, les informations sur les vendeurs, les conseils de contrôle qualité, les astuces de livraison et les tutoriels d\'achat liés à AllChinaBuy dans un hub facile à utiliser.',
  cta_primary: 'Explorer le AllChinaBuy Spreadsheet',
  cta_secondary: 'Commencer avec le Guide Débutant',
  cta_main_site: 'Visiter le Site Principal',
  cta_buy_now: 'Acheter Maintenant',
  trust_text: 'Ressource d\'information indépendante • Mise à jour régulièrement • Conçue pour une recherche de produits plus intelligente',
  section_what_is_title: 'Qu\'est-ce que le AllChinaBuy Spreadsheet ?',
  section_what_is_desc: 'Le AllChinaBuy Spreadsheet est une ressource centralisée conçue pour faciliter la recherche de produits. Explorez des ressources organisées sur les produits, les informations sur les vendeurs, les conseils de contrôle qualité, les références de livraison et les tutoriels d\'achat pratiques depuis un seul endroit.',
  section_resources_title: 'Tout Ce Dont Vous Avez Besoin pour Rechercher AllChinaBuy',
  card_spreadsheet_title: 'Spreadsheet',
  card_spreadsheet_desc: 'Explorez les ressources organisées sur les produits et les vendeurs AllChinaBuy.',
  card_shipping_title: 'Livraison',
  card_shipping_desc: 'Comprenez les méthodes de livraison, les coûts et les facteurs de comparaison pratiques.',
  card_qc_title: 'QC',
  card_qc_desc: 'Apprenez ce qu\'il faut vérifier avant d\'expédier les produits.',
  card_sellers_title: 'Vendeurs',
  card_sellers_desc: 'Apprenez comment rechercher des vendeurs et évaluer les informations sur les produits.',
  card_reviews_title: 'Avis',
  card_reviews_desc: 'Lisez des guides et analyses indépendants sur AllChinaBuy.',
  card_safety_title: 'Sécurité',
  card_safety_desc: 'Apprenez à identifier les liens suspects, les demandes de paiement et les risques courants.',
  section_categories_title: 'Catégories AllChinaBuy Spreadsheet',
  section_compare_title: 'Comparez Avant d\'Acheter',
  section_compare_desc: 'Différentes plateformes d\'achat peuvent avoir des workflows, des options de livraison et des expériences utilisateur différents. Nos guides de comparaison vous aident à comprendre les différences avant de prendre une décision.',
  cta_view_comparisons: 'Voir Toutes les Comparaisons',
  section_shipping_title: 'La Livraison Ne Devrait Pas Être une Supposition',
  section_shipping_desc: 'Le coût de livraison dépend de facteurs tels que la destination, le poids du colis, les dimensions, la méthode de livraison et les tarifs actuels du transporteur.',
  cta_explore_shipping: 'Explorer les Guides de Livraison',
  section_safety_title: 'Conçu avec la Sécurité en Tête',
  section_safety_desc: 'Avant de cliquer sur un lien de produit, d\'envoyer un paiement ou de partager des informations personnelles, vérifiez ce que vous utilisez. Notre Centre de Sécurité explique les risques courants, les liens suspects, la sécurité du compte et la sécurité des paiements.',
  cta_visit_safety: 'Visiter le Centre de Sécurité',
  section_guides_title: 'Derniers Guides AllChinaBuy',
  section_faq_title: 'Questions Fréquemment Posées',
  faq_q1: 'Qu\'est-ce que le AllChinaBuy Spreadsheet ?',
  faq_a1: 'Le AllChinaBuy Spreadsheet est une ressource d\'information indépendante qui organise la recherche de produits, les informations sur les vendeurs, les guides de livraison et les tutoriels d\'achat pour les utilisateurs recherchant des produits AllChinaBuy.',
  faq_q2: 'AllChinaBuy est-il légitime ?',
  faq_a2: 'AllChinaBuy est une plateforme d\'agent d\'achat connue. Nous fournissons des guides et ressources indépendants pour aider les utilisateurs à prendre des décisions éclairées.',
  faq_q3: 'AllChinaBuy est-il sûr ?',
  faq_a3: 'La sécurité dépend du respect des bonnes pratiques : vérifier les liens, utiliser des méthodes de paiement sécurisées, consulter les avis des vendeurs et comprendre les politiques de la plateforme.',
  faq_q4: 'Combien coûte la livraison AllChinaBuy ?',
  faq_a4: 'Les coûts de livraison varient selon la destination, le poids, les dimensions et la méthode de livraison. Nos guides expliquent comment estimer et comparer les coûts.',
  faq_q5: 'Où puis-je trouver des coupons AllChinaBuy ?',
  faq_a5: 'Les coupons et codes de réduction peuvent être disponibles via divers canaux. Nous mettons à jour notre guide de coupons avec des informations vérifiées.',
  faq_q6: 'Qu\'est-ce que l\'entrepôt AllChinaBuy ?',
  faq_a6: 'L\'entrepôt est l\'endroit où les produits sont stockés avant l\'expédition internationale. Comprendre les processus d\'entrepôt vous aide à mieux planifier vos commandes.',
  faq_q7: 'Comment fonctionne le QC AllChinaBuy ?',
  faq_a7: 'Le contrôle qualité implique l\'inspection des produits avant qu\'ils ne vous soient expédiés. Notre guide QC explique ce qu\'il faut vérifier et comment demander des inspections.',
  faq_q8: 'Comment utiliser un spreadsheet AllChinaBuy ?',
  faq_a8: 'Parcourez les catégories, filtrez par type de produit, comparez les vendeurs et utilisez le calculateur de livraison pour estimer les coûts avant de passer une commande.',
  final_cta_title: 'Commencez Votre Recherche AllChinaBuy',
  final_cta_desc: 'Que vous recherchiez votre premier produit ou que vous compariez les options de livraison et de vendeurs, commencez avec le AllChinaBuy Spreadsheet et explorez les guides qui correspondent à vos besoins.',
  footer_disclaimer: 'Ceci est une ressource d\'information indépendante et n\'est pas le site officiel AllChinaBuy sauf indication explicite.',
  footer_resources: 'Ressources',
  footer_links: 'Liens',
  footer_legal: 'Mentions Légales',
  breadcrumb_home: 'Accueil',
  article_read_more: 'Lire le Guide Complet',
  article_published: 'Publié',
  article_updated: 'Dernière Mise à Jour',
  article_author: 'Auteur',
  article_related: 'Articles Connexes',
  article_sources: 'Sources',
  article_toc: 'Table des Matières',
  dropdown_label: 'Parcourir les Catégories',
  category_button_label: 'Acheter',
};

export default home;